import { HardArrowLeft, PlaneEmptyYellow } from '@/resources/assets/images';
import Button from '@/components/Button/newButtons';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';

export default function HeaderRedesign({
	title,
	description,
	tooltip,
	backButton
}: {
	title: string;
	description?: string;
	tooltip?: string;
	backButton?: {
		goBack: () => void;
		label: string;
	};
}) {
	const [user] = useSelector(
		(state: RootState) => [state.user.getIn(['authorize', 'user']).toJS()],
		shallowEqual
	);

	const isUserOnboarding = user?.onboarding?.status === 'pending';

	if (backButton) {
		return (
			<div className="mb-3 flex min-h-[4.375rem] flex-shrink-0 flex-col gap-x-10 gap-y-2 rounded-lg px-4 pt-6 lg:flex-row lg:items-center lg:gap-y-6 lg:border-b lg:border-dm-gold lg:bg-dm-black lg:pb-6">
				{!isUserOnboarding && (
					<Button
						onClick={backButton.goBack}
						variant="text"
						size="large"
						leftIcon={<HardArrowLeft />}
						className="px-0"
					>
						{backButton.label}
					</Button>
				)}
				<div className="hidden h-[2.375rem] w-[0.125rem] bg-dm-grey lg:static" />
				<div className="flex flex-shrink-0 flex-col gap-1 text-dm-white">
					<span className="text-lg font-semibold">{title}</span>
					<span className="text-xs">{description}</span>
				</div>
				{tooltip && <p className="text-sm text-dm-white">{tooltip}</p>}
			</div>
		);
	}

	return (
		<div className="mb-3 flex h-[4.375rem] flex-shrink-0 items-center justify-between rounded-l-lg border-b border-dm-gold bg-dm-black py-6 pl-4 pr-10">
			<div className="flex items-center gap-2">
				<PlaneEmptyYellow className="h-8 w-8" />
				<div className="flex items-end gap-4">
					<span className="text-lg font-semibold">{title}</span>
					<span className="text-[12px]">{description}</span>
				</div>
			</div>
			{tooltip && (
				<div className="rounded-lg bg-dm-black3 px-4 py-2">
					If a business has responded to your email, your sequence
					will be paused for that business.
				</div>
			)}
		</div>
	);
}
